<div class="ion-margin-horizontal half-centered">
  <ion-img
    src="assets/img/mable/mable-last-minute-logo.png"
    alt="mable last minute"
  ></ion-img>
</div>
<h1 class="header-news-22-bold">How Last Minute Jobs Work</h1>

<p class="body-normal-16 ion-no-margin">If you need someone fast, Last Minute jobs speed up the usual process.</p>
<mable-how-it-works [items]="howItWorksItems"></mable-how-it-works>
<app-cancellation-policy buttonColor="purple-400"></app-cancellation-policy>
